import { styled } from "@mui/material/styles";

export const MUIStyled = styled;
